import React, { useEffect, useRef, useState } from 'react'
import BackArrow from './BackArrow'
import { useDispatch, useSelector } from 'react-redux';
import { endpoints } from '../../api/ApiEndPoints';
import { setAboutContent } from './About/cl_aboutSlice';

const CookiePolicy = () => {
  const topRef = useRef(null);

  useEffect(() => {
    topRef.current.scrollIntoView(true);
  }, []);

  const dispatch = useDispatch()
  const brandid=endpoints?.fasFasBrandId || 307;
  const {staticContent}=useSelector((state)=>state?.about);
  const [cookieInfo,setCookieInfo]=useState({});

  useEffect(()=>{
    if(brandid) dispatch(setAboutContent(brandid));
  },[dispatch,brandid]);

  useEffect(()=>{
    if(Array.isArray(staticContent)){
      const staticCookieContent=staticContent?.find(({link_name})=>link_name==='AML Policy');
      setCookieInfo(staticCookieContent);
    }
  },[staticContent]);

  return (
    <div className="SB-help SB-aml-policy" ref={topRef}>
      <div className="SB-pageHeader">
        <div className="SB-pageBackButton">
          <BackArrow />
        </div>
        <div className="SB-pageHeader-title">AML Policy</div>
      </div>
      <div className="SB-help-content">
      {Object.keys(cookieInfo).length ? 
         (
          <div dangerouslySetInnerHTML={{ __html:cookieInfo?.is_content }} />
       ) :<DefaultCookieInfo/>
      }
    </div>
    </div>
  )
}

export default CookiePolicy;

const DefaultCookieInfo=()=>{
  return(
    <div className="SB-help-content">
        <h3>Verification of Identity / AML (anti money laundering)</h3>
        <ul>
          <li>
            <p>
              You warrant that the details you supply when opening or updating your account are correct and you are the rightful owner of the money which you at any time deposit in your account.
            </p>
          </li>
          <li>
            <p>
              You authorise the Company to undertake verification checks from time to time as the Company itself may require or may be required by third parties (including, but not limited to, regulatory bodies) to confirm these facts.
            </p>
          </li>
          <li>
            <p>
              You agree that from time to time, upon our request, you may be required to provide additional details in respect of any of information you have provided the Company, including in relation to any deposits which you have made into your account.
            </p>
          </li>
          <li>
            <p>
              In certain circumstances the Company may have to contact you and ask you to provide further personal information such as: a notarised ID, proof of address, utility bill or financial details. Until such information has been supplied to its satisfaction, the Company may prevent any activity in relation to the account.
            </p>
          </li>
          <li>
            <p>
              Where the Company reasonably believes that deliberately incorrect information has been provided, the Company may retain any amount deposited.
            </p>
          </li>
          <li>
            <p className='SB-paragraph'>
              In the event that FasFas deems that a User has engaged or attempted to engage in fraudulent, unlawful, dishonest or improper activity while using the Service, or any other game manipulation, or the making of any fraudulent payment, including without limitation, use of a stolen credit card or fraudulent chargeback or money laundering or using shell bank accounts which are unaffiliated with a regulated financial group, FasFas shall be entitled to take such action as it sees fit, including, but not limited to:
            </p>
            <ul className='sublist hyphen-list'>
              <li>Immediately blocking a User's access to the Service</li>
              <li>Terminating a User's account with FasFas;</li>
              <li>Seizing the funds within a User's account;</li>
              <li>Disclosing such information (including the identity of the User) to financial institutions, relevant authorities and/or any person or entity that has the legal right to such information; and/or</li>
              <li>Taking legal action against a User.</li>
            </ul>
          </li>
          <li>
            <p>
              User Accounts are liable to be audited by internal, third-party / External and/or Government regulators to asses AML Policies are met.
            </p>
          </li>
          <li>
            <p>
              FasFas strongly advises its employees not to engage in relationships with politically exposed persons, their families or close associates.
            </p>
          </li>
          <li>
            <p>
              FasFas will retain records and KYC of its users in encrypted and anonymised format.
            </p>
          </li>
          <li>

            <p className='SB-paragraph'>
              FasFas limits the player to:
              <ul className='sublist sublist-circle'>
                <li>

                  <p>Max deposit allowed per user per day 		– KSH50,000/-</p>
                </li>
                <li>

                  <p>Max Withdrawal allowed per user per day 	- KSH70,000/- </p>
                </li>
              </ul>

            </p>
          </li>
          <li>
            <p>
              Winnings above KSH70,000/- are subject to verification and the user will be asked to provide additional KYC Documents, proof of bank account with a bank of repute governed by a regulated financial group. Such winnings may be subjected to deduction of taxes as applicable.
            </p>
          </li>
          <li>
            <p>
              The above policies are applicable to all of FasFas’s associates, including, management, staff, affiliates, agents, third-party business associates and individual users registered on the platform.
            </p>
          </li>
        </ul>
        <p>
          FasFas reserves the right to update the terms of this policy from time to time without prior intimation to it’s users.
        </p>
      </div>
  )
}
